import React, { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { RotatingSquare } from "react-loader-spinner";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../Contexts/AuthContext/AuthProvider";
const DepositMethodsEdit = () => {
    const { authUser } = useContext(AuthContext);
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updateData, setupdateData] = useState([]);

    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/deposit/method/view/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data.data);
                setLoading(false);
                setDataVulue({
                    network: data.data?.network || "",
                    wallet_address: data.data?.wallet_address || "",
                });
            });
    }, [updateData]);

    const [errorMessage, setErrorMessage] = useState([]);
    const [dataVulue, setDataVulue] = useState({});
    const refSubmitDis = useRef();

    const [QRCode, setQRCode] = useState("");

    const handleQRCode = (e) => {
        setQRCode(e.target.files[0]);
    };

    const handleSubmitData = async (event) => {
        event.preventDefault();
        refSubmitDis.current?.setAttribute("disabled", true);

        try {
            const formData = new FormData();

            Object.entries(dataVulue).forEach(([key, value]) => {
                formData.append(key, value);
            });

            if (QRCode) {
                formData.append("QRCode", QRCode);
            }

            const response = await axios.put(
                `https://api.velormall.com/api/admin/deposit/method/update/${id}`,
                formData
            );

            event.target.reset();

            toast.success(response?.data?.message, {
                position: "top-right",
                autoClose: 5000,
                theme: "colored",
            });

            setupdateData(response);

        } catch (error) {
            // console.log("ERROR:", error);

            // Validation errors
            const errors = error?.response?.data?.errors;

            if (errors) {
                setErrorMessage(errors)
            } else {
                // General error
                toast.error(
                    error?.response?.data?.message || "Something went wrong",
                    {
                        position: "top-right",
                        autoClose: 5000,
                        theme: "colored",
                    }
                );
            }

        } finally {
            refSubmitDis.current?.removeAttribute("disabled");
        }
    };
    const handleInputBlur = (event) => {
        const value = event.target.value;
        const field = event.target.name;
        const newData = { ...dataVulue };
        newData[field] = value;
        setDataVulue(newData);
    };

    if (loading) {
        return (
            <>
                <div className="loader-css">
                    <RotatingSquare
                        visible={true}
                        height="100"
                        width="100"
                        color="#4fa94d"
                        ariaLabel="rotating-square-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                </div>
            </>
        );
    }
    return (
        <>
            <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">Deposit Method Update</h6>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="card mb-4">
                        <form onSubmit={handleSubmitData}>
                            <div className="card-body">
                                <div className="payment-method-item">
                                    <div className="payment-method-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>QR Code Image</label>
                                                    <div className="image-upload">
                                                        <div className="thumb">
                                                            <div className="avatar-preview">
                                                                <div
                                                                    className="profilePicPreview"
                                                                    style={{ height: "120px" }}
                                                                >
                                                                    <img
                                                                        src={`https://api.velormall.com/${data?.QRCode}`}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="avatar-edit">
                                                                <input
                                                                    type="file"
                                                                    onChange={handleQRCode}
                                                                    className="profilePicUpload"
                                                                    id="profilePicUpload0"
                                                                    accept=".jpg, .png, .jpeg"
                                                                />
                                                                <label
                                                                    htmlFor="profilePicUpload0"
                                                                    className="bg--primary"
                                                                >
                                                                    Image
                                                                </label>
                                                                <small class="mt-2  ">
                                                                    Supported files: <b>jpeg, jpg, png</b>. |
                                                                    Will be resized to:
                                                                    <b>800x800</b>
                                                                    px.
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" col-md-8 ">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            Network Type
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="network"
                                                            onBlur={handleInputBlur}
                                                            id="heading"
                                                            defaultValue={data?.network}
                                                        />
                                                    </div>
                                                    {errorMessage?.network && (
                                                        <span className="text-danger pt-2">
                                                            {errorMessage?.network?.msg}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            Wallet Address
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="wallet_address"
                                                            onBlur={handleInputBlur}
                                                            defaultValue={data?.wallet_address}
                                                            id="heading"
                                                        />
                                                    </div>
                                                    {errorMessage?.wallet_address && (
                                                        <span className="text-danger pt-2">
                                                            {errorMessage?.wallet_address?.msg}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button
                                    type="submit"
                                    ref={refSubmitDis}
                                    className="btn btn-primary w-100 h-45"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DepositMethodsEdit;
